<template>
    <v-dialog v-model="value" max-width="500px" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Atualizar a data de fechamento
                    <v-icon right>
                        mdi-update
                    </v-icon>
                </span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-alert v-if="error_message" type="error">
                        {{ error_message }}
                    </v-alert>
                    <v-form ref="formEdit">
                        <v-row>
                            <v-col cols="6">
                                <base-date-picker
                                    v-model="credit_card.closing_date"
                                    label="Dia do fechamento"
                                    :rules="closing_date_rules"
                                ></base-date-picker>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="credit_card.name"
                                    label="Nome do cartão"
                                    disabled
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    :disabled="saving"
                    @click="close"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="success"
                    text
                    :disabled="saving"
                    @click="save"
                >
                    Salvar
                </v-btn>
            </v-card-actions>
            <v-progress-linear
                v-if="saving"
                indeterminate
                height="6"
            ></v-progress-linear>
        </v-card>
        <base-notify
            v-model="show_notify"
            :type="notify_type"
            :message="notify_message"
        >
        </base-notify>
    </v-dialog>
</template>

<script>
import BaseNotify from "../../../components/BaseNotify";
import BaseDatePicker from "../../../components/BaseDatePicker";
import { mapActions } from "vuex";

export default {
    components: {
        BaseNotify,
        BaseDatePicker
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        creditCardId: {
            type: Number,
            required: false,
            default: null
        }
    },
    data() {
        return {
            closing_date_rules: [
                v => !!v || "Informe uma data de fechamento",
            ],
            list_dias: Array.from({length: 31}, (_, i) => i + 1),
            loading: false,
            saving: false,
            error_message: null,
            show_notify: false,
            notify_type: null,
            notify_message: "",
            credit_card: {
                name: null,
                limit: null,
                due_date: null,
                closing_date: null
            }
        };
    },
    watch: {
        value(new_value) {
            if (new_value) {
                this.read();
            }
        }
    },
    methods: {
        ...mapActions("credit_card", ["ActionDoReadCreditCard", "ActionDoEditCreditCard"]),
        close() {
            this.$refs.formEdit.reset();
            this.$emit("close");
            this.$emit("input", false);
        },
        async read() {
            this.loading = true;

            if (this.creditCardId) {
                await this.ActionDoReadCreditCard(this.creditCardId).then(response => {
                    this.credit_card = response;
                    this.credit_card.closing_date = (new Date(this.credit_card.closing_date)).toISOString().substr(0, 10);
                    this.loading = false;
                });
            } else {
                this.close();
            }
        },
        save() {
            this.saving = true;

            if (this.$refs.formEdit.validate()) {
                try {
                    this.ActionDoEditCreditCard({
                        id: this.credit_card.id,
                        name: this.credit_card.name,
                        limit: Number.isInteger(this.credit_card.limit) ? this.credit_card.limit : this.credit_card.limit.replace(/[^0-9]+/g, ""),
                        due_date: this.credit_card.due_date,
                        closing_date: this.credit_card.closing_date,
                        refresh_closing_date: false
                    }).then(response => {
                        this.error_mesasge = null;

                        if (response.credit_card) {
                            this.show_notify = true;
                            this.notify_type = "success";
                            this.notify_message = "Cartão salvo com sucesso!";
                            this.saving = false;
                            this.$refs.formEdit.reset();
                            this.close();
                        } else {
                            this.show_notify = true;
                            this.notify_type = "error";
                            this.notify_message = "Ocorreu um erro!";
                            this.saving = false;
                            this.error_mesasge = response.error;
                        }
                    });
                } catch (error) {
                    this.show_notify = true;
                    this.notify_type = "error";
                    this.notify_message = "Ocorreu um erro!";
                    this.saving = false;
                    this.error_mesasge = error.response.data.error;
                }
            } else {
                this.saving = false;
            }
        }
    }
};
</script>
